import React, { useRef, useState, useCallback, useEffect } from "react";

import {
    Box
} from "@mui/material";

// import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import { useNavigate, Link } from "react-router-dom";

import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import DataGridToolbar from "../../common/DataGridToolbar";
import DataGridTable from "../../common/DataGridTable";
import DataGridRowActionMenu from "../../common/DataGridRowActionMenu";
import CommonRestricted from "../../common/CommonRestricted";

import { icons } from "../../common/CommonIcons";
import { useDataGridParams } from "../../../hooks/useDataGridParams";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useWallets, targetTypes } from "../../../hooks/api/useWallets";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from "../../../hooks/useSystemHead";
import {
    usePermissions, scopeIds, scopeTypes, functionTypes
} from "../../../hooks/usePermissions";
import { useTranslations } from "../../../hooks/useTranslations";

const ListWallets = ({
    routeType
}) => {

    const { t } = useTranslations({ ns: ["common", "@wallet"] });

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove, get, update } = useWallets({ targetType: targetTypes.wallet });

    const {
        defineColumns,
        columns,
        filterValues,
        getRenderColumnLink,
        getRenderColumnBooleanDisplay,
        getRenderColumnTextDisplay
    } = useDataGridParams("id");
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.wallet.id,
        scopeTypes.wallet.wallet.id
    );

    const [selectedIds, setSelectedIds] = useState([]);
    const [refreshDataGrid, setRefreshDataGrid] = useState(0);
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType);

    const gridRef = useRef();

    const resetDataGridTableSelection = () => {
        setSelectedIds([]);
    };

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try {

            // props.dataTypes = ["location_count"]

            const result = await list(props);

            return {
                data: result?.data?.wallets,
                count: result?.data?.total
            };

        } catch (error) {

            promptMessage(false, `Error getting results (${error?.message})`);

            return {
                data: [],
                count: 0
            };
        }
    };

    useEffect(() => {
        defineColumnsView();
    }, []);

    const defineColumnsView = () => {
        defineColumns([
            {
                name: "name",
                header: t("walletName"),
                renderValue: ({ value, cellProps }) => {
                    if (isPermissionAllow(
                        { functionType: functionTypes.pageUpdate.id }) ===
                        false) {
                        return getRenderColumnTextDisplay(value);
                    }

                    let path = getRoute(
                        `settings/wallet/update/${cellProps.data.id}`);

                    return getRenderColumnLink(path, value);

                }
            },
            {
                name: "wallet_key", header: t("walletKey")
            },
            {
                name: "currency", header: t("walletCurrency")
            },
            {
                name: "conversion_rate", header: t("conversionRate")
            },
            // { 
            //     name: 'lastname', header: 'Last Name' 
            // },
            {
                name: "primary_wallet", header: t("isPrimaryWallet"),
                renderValue: ({
                    cellProps,
                    value
                }) => getRenderColumnBooleanDisplay(value,
                    [t("yes"), t("no")], ["primary", "default"], ""
                )
            },
            {
                name: "description", header: t("description")
            },

            {
                name: "status",
                header: t("status"),
                renderValue: ({
                    cellProps,
                    value
                }) => getRenderColumnBooleanDisplay(value,
                    [t("enabled"), t("disabled")], ["primary", "default"],
                    ""
                )
            }
        ]);
    };

    const handleDelete = async () => {

        try {
            let result = await remove(
                { ids: selectedIds, targetType: targetTypes.wallet });

            promptMessage(true, result?.message);
            setRefreshDataGrid(currentVal => currentVal + 1);

        } catch (error) {
            promptMessage(false, error?.message);
        }

    };

    const RenderToolbar = () => {

        const getToolbarMainMenus = () => {

            let props = [];

            if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
                props.push({
                    displayIconName: icons.plus,
                    onClick: () => {
                        navigate(getRoute("settings/wallet/new"));
                    }
                });
            }

            return props;
        };

        const getActionOnClick = () => {

            let handleFunction = null;

            if (isPermissionAllow({ functionType: functionTypes.remove.id })) {
                handleFunction = handleDelete;
            }

            return handleFunction;
        };

        return (
            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={
                    getToolbarMainMenus()
                }
                actionOnClickRemove={
                    getActionOnClick()
                }
                actionMenus={[]}
            />
        );
    };

    const RenderDataGridTable = () => {

        return (
            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn:
                        isPermissionAllow(
                            { functionType: functionTypes.remove.id }),
                    columns,
                    defaultFilterValue: filterValues,
                    onSelectionChange: (items) => {
                        setSelectedIds(
                            items
                        );
                    }
                }}

            />
        );
    };

    const getBreadcumbActionMenus = () => {

        let props = [];

        if (isPermissionAllow({
            scopeType: scopeTypes[scopeIds.wallet.id].walletUser.id,
            functionType: functionTypes.pageList.id
        })) {
            props.push({
                displayText: t("manageWalletUsers"),
                onClick: () => {

                    navigate(getRoute(`settings/walletUsers`));
                }
            });
        }

        return props;
    };

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.wallets })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("wallets")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("wallets"),
                        props: {
                            // underline: "hover",

                        }
                    }
                ]}
            />

            {
                isPermissionAllow(
                    { functionType: functionTypes.pageList.id }) ?
                    <>
                        {
                            RenderToolbar()
                        }
                        {
                            RenderDataGridTable()
                        }
                    </>
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    );
};

export default ListWallets;
